module.exports = (function() { return this["wp"]["blocks"]; }());